import React, {Component} from "react"
import {Container} from '../styled'
import Image from '../../../../styled/content/image/index'
import Text from '../../../../styled/content/text/index'
import Plus from '../../../../../images/plus.png'
import {Link} from "react-router-dom"


class CardAdd extends Component {
    render() {
        const {to,text} = this.props
        return (
            <Container justify="center"  flow="column">
                <Link to={to}>
                    <Image src={Plus} alt="Adicionar" size="3rem"/>
                    <Text>Adicionar novo {text}</Text>
                </Link>
            </Container>
        )
    }
}

export default CardAdd